<template>
  <div class="commonForm-container">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :inline="inline"
      :label-width="labelWidth"
    >
      <template v-for="item in formItemList">
        <!-- 输入框类型 -->
        <template v-if="item.type === 'input'">
          <el-form-item
            :label="item.label"
            :prop="item.model"
            :key="item.model"
          >
            <el-input
              v-model.trim="form[item.model]"
              :type="`${item.category || 'text'}`"
              :style="`width: ${item.width || '100%'}`"
              :clearable="item.clearable === undefined || item.clearable"
              filterable
              :placeholder="item.placeholder"
              :disabled="item.disabled ? item.disabled : false"
            />
          </el-form-item>
        </template>

        <!-- 下拉选择框 -->
        <template v-if="item.type === 'select'">
          <el-form-item
            :label="item.label"
            :prop="item.model"
            :key="item.model"
          >
            <el-select
              v-model.trim="form[item.model]"
              :style="`width:${item.width || '100%'}`"
              clearable
              :placeholder="item.placeholder || ''"
            >
              <el-option
                v-for="(i, key) in item.options"
                :key="i[item.value] || key"
                :label="i[item.label] || i.label"
                :value="i[item.value] || i.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>

        <!-- 日期范围选择器 -->
        <template v-if="item.type === 'date-picker-daterange'">
          <el-form-item
            :prop="item.model"
            :label="item.label"
            :key="item.model"
          >
            <el-date-picker
              v-model.trim="form[item.model]"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <!-- 日期选择器 -->
        <template v-if="item.type === 'date-picker-data'">
          <el-form-item
            :prop="item.model"
            :label="item.label"
            :key="item.model"
          >
            <el-date-picker
              v-model.trim="form[item.model]"
              type="date"
              :clearable="item.clearable === undefined || item.clearable"
              :placeholder="item.placeholder"
              :format="item.format || 'yyyy-MM-dd'"
              :value-format="item.format || 'yyyy-MM-dd'"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <!-- 开关 -->
        <template v-if="item.type === 'switch'">
          <el-form-item
            :prop="item.model"
            :label="item.label"
            :key="item.model"
          >
            <el-switch v-model="form[item.model]"></el-switch>
          </el-form-item>
        </template>

        <!-- 复选框 -->
        <template v-if="item.type === 'checkbox'">
          <el-form-item
            :prop="item.model"
            :label="item.label"
            :key="item.model"
          >
            <el-checkbox-group v-model="form[item.model]">
              <el-checkbox
                :label="item.label"
                :key="index"
                v-for="(item, index) in item.options"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </template>

        <!-- 单选框 -->
        <template v-if="item.type === 'radio'">
          <el-form-item
            :prop="item.model"
            :label="item.label"
            :key="item.model"
          >
            <el-radio-group v-model="form[item.model]">
              <el-radio
                :label="item.label"
                :key="index"
                v-for="(item, index) in item.options"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
        </template>

        <!-- 输入框textarea -->
        <template v-if="item.type === 'textarea'">
          <el-form-item
            :label="item.label"
            :prop="item.model"
            :key="item.model"
          >
            <el-input
              type="textarea"
              v-model.trim="form[item.model]"
              :style="`width: ${item.width || '100%'};`"
              :clearable="item.clearable === undefined || item.clearable"
              :placeholder="item.placeholder"
              :rows="item.row || 5"
            />
          </el-form-item>
        </template>

        <!-- 密码输入框 -->
        <template v-if="item.type === 'password'">
          <el-form-item
            :label="item.label"
            :prop="item.model"
            :key="item.model"
          >
            <el-input
              v-model.trim="form[item.model]"
              type="password"
              :style="`width: ${item.width || '100%'}`"
              :clearable="item.clearable === undefined || item.clearable"
              filterable
              :placeholder="item.placeholder"
            />
          </el-form-item>
        </template>

        <!-- ... -->
      </template>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'CommonForm',
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    // 生成el-form-item的数组
    formItemList: {
      type: Array,
      default: () => []
    },
    // 是否行内表单模式
    inline: {
      type: Boolean,
      default: false
    },
    // el-form-item的label宽度
    labelWidth: {
      type: String,
      default: '200px'
    },
    // 表单校验规则
    rules: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  methods: {
    // 返回经过校验的表单
    returnForm() {
      // 表单校验
        this.$refs['form'].validate(valid => {
        this.$emit('getForm', { form: this.form, valid: valid })
      })
    },
    // 重置表单
    resetForm() {
      // 重置复选框
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  text-align: right;
}

::v-deep .el-textarea__inner {
  //el_input中的隐藏属性
  resize: none; //禁止拉伸
}
</style>
